var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OSwitch',_vm._b({attrs:{"value":_vm.value,"role":"switch"},on:{"input":_vm.onInput}},'OSwitch',Object.assign({}, _vm.$attrs),false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }